import { Link } from "react-router-dom";
import { ArrowUpRight, Cpu, Workflow, Network, Factory, Compass, Activity } from "lucide-react";
import { SERVICES } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

const ICONS = { Cpu, Workflow, Network, Factory, Compass, Activity };

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="What we do"
        title={<>Engineering services<br/>built for <span className="text-[var(--primary)]">critical industries.</span></>}
        subtitle="Six interconnected disciplines, one accountable engineering team. Whether you need a single sensor designed or a national IoT rollout, UMD owns the outcome end-to-end."
        image="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="py-24 md:py-32 container-wide">
        <div className="grid gap-px bg-[var(--border)] border border-[var(--border)]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Cpu;
            return (
              <Reveal key={s.slug} delay={i * 60}>
                <Link to={`/services/${s.slug}`} data-testid={`services-row-${s.slug}`} className="grid md:grid-cols-12 gap-8 bg-white p-8 md:p-10 hover:bg-[#0a0a0a] hover:text-white group transition-colors duration-500">
                  <div className="md:col-span-1 font-mono-tech text-sm text-[var(--muted-fg)] group-hover:text-[var(--primary)]">{s.code}</div>
                  <div className="md:col-span-1"><Icon size={28} strokeWidth={1.4} className="group-hover:text-[var(--primary)] transition-colors" /></div>
                  <div className="md:col-span-4">
                    <h3 className="font-display text-2xl md:text-3xl leading-tight tracking-tight">{s.title}</h3>
                  </div>
                  <div className="md:col-span-5 text-[var(--muted-fg)] group-hover:text-white/70 text-base leading-relaxed">{s.short}</div>
                  <div className="md:col-span-1 flex justify-end items-start">
                    <ArrowUpRight size={24} className="group-hover:translate-x-2 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* Process */}
      <section className="py-24 md:py-32 bg-[#fafafa]">
        <div className="container-wide">
          <div className="grid md:grid-cols-12 mb-16">
            <div className="md:col-span-7">
              <div className="eyebrow mb-6">How we work</div>
              <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">A process<br/>engineered for outcomes.</h2>
            </div>
          </div>
          <div className="grid md:grid-cols-5 gap-px bg-[var(--border)] border border-[var(--border)]">
            {[
              { n: "01", t: "Discover", d: "Listen, scope, audit existing systems and constraints." },
              { n: "02", t: "Design", d: "Architect the right solution — silicon to dashboard." },
              { n: "03", t: "Prototype", d: "Bench, certify and field-trial before full commitment." },
              { n: "04", t: "Deploy", d: "Manufacture locally, install nationally, integrate enterprise." },
              { n: "05", t: "Sustain", d: "24/7 support, lifecycle management, continuous improvement." },
            ].map((p, i) => (
              <Reveal key={p.n} delay={i * 80} className="bg-white p-8">
                <div className="font-display text-5xl text-[var(--primary)] tracking-tight">{p.n}</div>
                <div className="font-display text-xl mt-6 tracking-tight">{p.t}</div>
                <p className="text-sm text-[var(--muted-fg)] mt-3 leading-relaxed">{p.d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
